export default __webpack_public_path__ + "static/media/illustration-together-600px.56f8d25c.svg";